import React, {useState} from "react"
import Data from "../../../../data"

// components
import Features from "./Features"

// the component
function HomeDeliveryInfos({activity}) {
  const [items] = useState([
    {key:"location", text:"Beschenkter wählt die Lieferadresse"},
    {key:"payment", text:"Das Erlebnis kann erst nach eingegangener Zahlung eingelöst werden"},
    {key:"preparation", text:`Wunschtermin muss mindestens ${Data.Properties.getRedeemTimeframe().homedelivery} Tage im Voraus angegeben werden`},
    {key:"specificday", text:"Wenn du den Beschenkten an einem bestimmten Tag direkt mit dem Erlebnis überraschen willst, löst du den Gutschein am besten selbst ein und wählst bereits das gewünschte Datum aus."}
  ])

  // not homedelivery? don't render
  if(!activity.isHomeDelivery) {
    return null
  }

  // render
  return (
    <Features 
      title="Hinweise" 
      items={items}
    />
  )
}

export default HomeDeliveryInfos